import React from "react";
import { Outlet } from "react-router-dom";
import Box from "@mui/material/Box";
import Sidebar from "./sidebar/Sidebar";
// import { useSelector } from "react-redux";

const Layout = () => {
  // const user = useSelector((state) => state.auth.user);

  // useEffect(() => {
  //   console.log("user", user);
  // }, [user]);

  return (
    <Box sx={{ display: "flex" }}>
      <Sidebar />
      <Box
        sx={{
          marginLeft: "120px",
          padding: "2em",
          backgroundColor: "#f5f5f5",
          width: "calc(100vw - 120px)",
          minHeight: "100vh",
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
};

export default Layout;
